import type { FaireBrandEntity } from "../../entity_types/brand";

export const brand_proto_misewell: FaireBrandEntity = {
  token: "brand_proto_misewell",
  type: "brand",
  name: "Misewell",
  rating: 5,
  reviewCount: 18,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
